import { formatNumber, onlyNumbers } from "services/helper";

export const tipHead = "tooltipHead";
export const tipBody = "tooltipBody";
export const tipFooter = "tooltipFooter";
export const tip = {
  role: "tooltip",
  type: "string",
  p: { html: true },
};

export function getTip(type, data, endingDate) {
  const { value, label, color } = { ...data };
  if (type === tipHead) {
    return `<div style="padding: 5px; font-size: 16px"><p>${data} ${
      endingDate ? ` até ${endingDate}` : ""
    }</p>`;
  } else if (type === tipBody)
    return `
        <div style="display: flex;">${getTipDot(color)}${label}: ${value}</div>
      `;
  else if (type === tipFooter)
    return data
      ? `<p style="font-weight: 700;">Total: ${data}</p></div>`
      : "</div>";
}

export function getTipsObj(initialDate, endingDate) {
  return getTip(tipHead, initialDate, endingDate);
}

export function getTotalsObj(type) {
  //dataTypes = dataTypes?.filter((t) => t === "clicks" || t === "impressions");
  //let totals = {};
  if(type=== "clicks" || type === "impressions") {
    return 0;
  }
  //dataTypes?.forEach((t) => (totals[t] = 0));
  //return totals;
}

export function addTipsInLines(charLine, tooltip, jump = 2) {
  for (let i = jump; i < charLine?.length; i += 2) charLine[i] = tooltip;
  return charLine;
}

export function getTipDot(color) {
  return `<div style="width: 15px; height: 15px; margin: 0px 5px; border-radius: 50px; background-color: ${color}; border: 1px solid black;"></div>`;
}

export function isClickOrImpression(type) {
  return type === "clicks" || type === "impressions";
}

export function formatValue(type, value, rawValue) {
  const isCTR = type === "ctr";
  const isPosition = type === "position";
  const isFcpOrLcpOrTtfb = type === "fcp" || type === "lcp" || type === "ttfb";
  const isFIDOrInp = type === "fid" || type === "inp";
  const isCLS = type === "cls";
  const isStatus = isWVStatus();

  if (!rawValue) {
    if (isClickOrImpression(type)) return formatNumber(value);
    else if (isCTR) return `${(value * 100)?.toFixed(2)}%`;
    else if (isPosition) return value?.toFixed(1);
    else if (isFcpOrLcpOrTtfb) return `${value}ms`;
    else if (isFIDOrInp) return `${value}ms`;
    else if (isCLS || isStatus) return `${value}%`;
  } else {
    if (isClickOrImpression(type))
      return parseInt(onlyNumbers(formatNumber(value)));
    else if (isCTR) return parseFloat((value * 100)?.toFixed(1));
    else if (isPosition) return parseFloat(value?.toFixed(1));
    else if (isFcpOrLcpOrTtfb) return parseFloat(value?.toFixed(1));
    else if (isFIDOrInp) return value;
    else if (isCLS || isStatus) return value;
  }
  return value;
}

export function isWVStatus(type) {
  return type === "good" || type === "needsImprovements" || type === "poor";
}
